const NotificationLogLevels = {
  ALARM: 'alarm',
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
};

export { NotificationLogLevels };
export default { levels: NotificationLogLevels };
